import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { useEditingProps, useEditItem, useGetZ3kObject, } from 'z3k-settings/components/utils/unpack-props';
import { MaterialRadioGroupControl, StrictNumberInput } from 'shared/components/fields';
import { Box, InputAdornment, Typography } from '@mui/material';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { SettingContainer } from 'z3k-settings/components/material-utils/settings-card';
import { Control } from 'shared/components/fields/control';
import { TextInputWrapper } from 'shared/components/fields/text';
import { ComponentObjectForTopic } from 'z3k-settings/components/mqtt-topics/object_for_topic';
import { setFlag } from 'z3k-parser/lib';
import { MQTTTopic } from 'z3k-parser/model/z3k-config/57-mqtt';
import { FlagSelector } from 'z3k-settings/components/material-utils/flag-selector';
import Logo from './Home_Assistant_logo.svg';
import { HelpIcon } from 'shared/components/fields/help-icon';
const z3k_name = 'mqtt_topics';
export const MQTTTopicsComponent = memo(function MQTTDeviceControlImpl() {
    const item = useGetZ3kObject(z3k_name);
    const id = item.id;
    const nameEditingProps = useEditingProps(id, z3k_name, 'name');
    const periodEditingProps = useEditingProps(id, z3k_name, 'period');
    const qosEditingProps = useEditingProps(id, z3k_name, 'qos');
    const homeAssistantEditingProps = useEditingProps(id, z3k_name, 'setting_register');
    const onChange = useEditItem(id, z3k_name);
    const flagPublicationTopic = useMemo(() => MQTTTopic.isPublicationTopic(item), [item]);
    const qos_options = useMemo(() => [
        {
            label: '0',
            value: '0',
            help_id: null,
        },
        {
            label: '1',
            value: '1',
            help_id: null,
        },
        {
            label: '2',
            value: '2',
            help_id: null,
        },
    ], []);
    const qos_radio_field = useCallback((input_props) => (_jsx(MaterialRadioGroupControl, { control_values: qos_options, ...input_props })), [qos_options]);
    const params_options = useMemo(() => [
        {
            label: 'Публикация',
            value: '1', //MQTTTopic.Params.PUBLICATION_TOPIC,
            help_id: null,
        },
        {
            label: 'Подписка',
            value: '2', //MQTTTopic.Params.SUBSCRIPTION_TOPIC,
            help_id: null,
        },
    ], []);
    const is_params_state = useMemo(() => (flagPublicationTopic ? '1' : '2'), [flagPublicationTopic]);
    const onChangeParams = useCallback((new_value) => {
        if (new_value === '1') {
            const delete_params = setFlag(item, MQTTTopic.Params.SUBSCRIPTION_TOPIC, false);
            const new_params = setFlag(delete_params, MQTTTopic.Params.PUBLICATION_TOPIC, true);
            onChange({ ...new_params, type_object: 255, link_list: [] });
        }
        else {
            let delete_params = setFlag(item, MQTTTopic.Params.PUBLICATION_TOPIC, false);
            if (MQTTTopic.isHomeAssistant(item)) {
                delete_params = setFlag(delete_params, MQTTTopic.Params.HOME_ASSISTANT, false);
            }
            const new_params = setFlag(delete_params, MQTTTopic.Params.SUBSCRIPTION_TOPIC, true);
            onChange({ ...new_params, type_object: 255, link_list: [] });
        }
    }, [flagPublicationTopic, item]);
    const period_field = useCallback((input_props) => (_jsx(StrictNumberInput, { ...input_props, step: 0.1, min: 0.2, max: 300, editDividedBy: 1000, endAdornment: _jsx(InputAdornment, { position: "end", children: "\u0441\u0435\u043A" }) })), []);
    return (_jsx(ErrorBoundary, { children: _jsxs(SettingContainer, { children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", field: TextInputWrapper, help_id: "mqtt_name", ...nameEditingProps }), _jsx(Control, { label: "QOS", field: qos_radio_field, help_id: "mqtt_qos", sxProps: { '.MuiFormGroup-root': { flexDirection: 'row' } }, value: qosEditingProps.value.toString(), onChange: (value) => qosEditingProps.onChange(parseInt(value)), validation_result: null, validation_warnings_result: null }), _jsx(MaterialRadioGroupControl, { control_values: params_options, onChange: onChangeParams, main_label: "\u0422\u0438\u043F Topic", value: is_params_state }), flagPublicationTopic && (_jsxs(_Fragment, { children: [_jsx(Control, { label: "\u041F\u0435\u0440\u0438\u043E\u0434 \u043E\u043F\u0440\u043E\u0441\u0430", field: period_field, help_id: "mqtt_period", sxProps: { justifyContent: 'flex-start' }, ...periodEditingProps }), _jsx(ComponentObjectForTopic, {}, item.id), _jsx(FlagSelector, { mask: MQTTTopic.Params.HOME_ASSISTANT, custom_label: _jsxs(Box, { display: 'flex', alignItems: "center", children: [_jsx(Typography, { sx: { pr: '5px' }, children: "\u0444\u043E\u0440\u043C\u0430\u0442 Home Assistant" }), _jsx(Logo, { width: '24', height: '24' }), _jsx(HelpIcon, { help_id: 'home_assistant_name' })] }), ...homeAssistantEditingProps })] }))] }) }));
});
